import { aliapp, os } from 'amfe-env'
import windvane from '@ali/lib-windvane'
import hybrid from '@ali/hybrid'

export const isInBrowser = !aliapp || (aliapp.appname !== 'TB' && aliapp.appname !== 'TM')

export const loadImage = (src) => {
  return new Promise((resolve, reject) => {
    let image = new Image()
    image.src = src
    image.onload = () => {
      resolve(image)
    }
    image.onerror = (err) => {
      reject(err)
    }
  })
}

export const timeoutPromise = (time) => {
  return new Promise(resolve => {
    setTimeout(resolve, time)
  })
}

export const openWindow = url => {
	if(aliapp && (aliapp.appname === 'TB' || aliapp.appname === 'TB-PD' || aliapp.appname === 'TM')){
		if (os.isIOS) {
			windvane.call('Base', 'openWindow', { 'url': url }, result => {
				result.errorCode && window.open(url)
			})
		} else {
			windvane.call('WVNative', 'openWindow', { 'url': url }, result => {
				result.errorCode && window.open(url)
			}, er => {
				window.open(url)
			})
		}
	} else {
		window.location.href = url
	}
}

export const getDeviceInfo = () => {
	return new Promise((resolve, reject) => {
		if (aliapp && (aliapp.appname === 'TB' || aliapp.appname === 'TB-PD' || aliapp.appname === 'TM')) {
			windvane.call('WVNativeDetector', 'getModelInfo', {}, (e) => {
				resolve(e)
			}, (e) => {
				resolve({})
			});
		} else {
			resolve({})
		}
	})
}

export const Toast = (msg, time) => {
	const params = {
		message: msg || 'Toast',
		duration: time || 2
	}
	if (aliapp) {
		windvane.call('WVUIToast', 'toast', params, () => {
		}, (e) => {
			alert(msg)
		})
	} else {
		alert(msg)
	}
}

export const showShare = (title, text, image, url = window.location.href) => {
	let params = {
		title,
		text,
		image,
		url: url || window.location.href
	}

	return new Promise((resolve, reject) => {
		hybrid.share(params, res => {
			if (res.errorCode && res.errorCode !== 6) {
				Toast('拉起分享失败')
				reject(res)
				return
			}		
			resolve(res)		
		})
	})
}

export const goldRecord = (logkey, gmkey, gokey, chksum) => {
	if (window.goldlog) {
		try {
			window.goldlog.record(logkey, gmkey, gokey || '', chksum)
		} catch (e) {
		}
	} else {
		setTimeout(function () {
			goldRecord(logkey, gmkey, gokey, chksum)
		}, 200)
	}
}

export const setFestivalStyle = () => {
	if (aliapp) {		
		windvane.call('WebAppInterface', 'setFestivalStyle', {
			naviBar: 'none'
		})
	}
}

export const hideTitleBar = () => {
	if(aliapp && ['TM'].indexOf(aliapp.appname) !== -1) {
		hybrid.hideTitle() // 隐藏titlebar
	}
}

export const nativeBack = (historyBackMode = false) => {
	if(!historyBackMode && aliapp) {
		windvane.call('WVNative', 'nativeBack', {}, (e) => {
		}, (ev) => {
			window.history.back()
		})
	} else {
		window.history.back()
	}
}

export const addCart = (itemId, actionType = '0') => {
	const options = { 
		'serviceId': 'msoa.taobao.detail.showsku',
		'version': '1.0',
		'sceneName': 'detail',
		'dataType': 'json',
		'params': {
			itemId,
			actionType
		}
	}
	return new Promise((resolve, reject) => {
		windvane.call('MSOAWVService', 'requestService', options, e => {
			resolve(e)
		}, err => {
			reject(err)
		})
	})	
}



// WEBPACK FOOTER //
// ./src/Util/index.js